// Pure JWT helpers — no signature verification, only payload inspection.
// Server still owns the security boundary; this is for UX (proactive redirect).

// Server-side ConfigureJwtBearerOptions uses the same 30s skew so the client
// redirects just before the server would reject — users see a clean /login
// redirect instead of a mid-call 401.
const DEFAULT_SKEW_SECONDS = 30;

function base64UrlDecode(segment) {
  let s = segment.replace(/-/g, '+').replace(/_/g, '/');
  const pad = s.length % 4;
  if (pad === 2) s += '==';
  else if (pad === 3) s += '=';
  else if (pad !== 0) return null;
  return atob(s);
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const json = base64UrlDecode(parts[1]);
    if (json === null) return null;
    return JSON.parse(json);
  } catch {
    return null;
  }
}

// Returns true ONLY if exp claim is present AND the token has expired
// (after applying skew). Tokens without an exp claim return false — this
// matches the server's legacy-token-passthrough behavior for Phoenix_Back_End
// forwarded tokens during the S3DEV2-7242 migration.
export function isJwtExpired(token, skewSeconds = DEFAULT_SKEW_SECONDS) {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== 'number') return false;
  const nowSec = Math.floor(Date.now() / 1000);
  return payload.exp + skewSeconds < nowSec;
}

// Returns the milliseconds until the token expires (after skew), or null if
// the token has no exp claim or cannot be decoded. Negative values mean the
// token is already past expiration.
export function msUntilExpiration(token, skewSeconds = DEFAULT_SKEW_SECONDS) {
  const payload = decodeJwtPayload(token);
  if (!payload || typeof payload.exp !== 'number') return null;
  return (payload.exp - skewSeconds) * 1000 - Date.now();
}
